const params = (data) => {
  return Object.keys(data)
    .map((key) => `${key}=${encodeURIComponent(data[key] ? data[key] : "")}`)
    .join("&");
};

export default params;
